interface Vector3D {
  x: number;
  y: number;
  z: number;
}

export const vectorToString = (vector: Vector3D) =>
  `${vector.x} ${vector.y} ${vector.z}`;
